import React, { useState } from "react";
import { useFormikContext } from "formik";
import amex from "../../../../../../../images/v2/amex24x24.svg";
import discover from "../../../../../../../images/v2/discover24x24.svg";
import mastercard from "../../../../../../../images/v2/master24x24.svg";
import visa from "../../../../../../../images/v2/visa24x24.svg";
import TextInput from "../../../../../components/form/text-input";
import useUserStore from "../../../../../stores/user";
import useOrganizationStore from "../../../../../stores/organization";
import PinBasedDebit from "../components/pin-based-debit";
import { getSoftLimitWarning } from "../../../utils/soft-limit";
import styles from "./style.module.scss";
import Switch from "../../../../../components/form/switch";

const KurvPricing = () => {
  const { values, errors, touched, handleBlur, handleChange, setFieldValue } =
    useFormikContext();

  const user = useUserStore((state) => state.user);
  const pricingDefaults = useOrganizationStore(
    (state) => state.pricingDefaults,
  );
  const nonEditableTemplateOrPricingRestricted =
    values.nonEditableTemplateApplied ||
    user?.organization?.pricing_restricted === 1;

  const [backup, setBackup] = useState({
    kurv_pricing_amex_rate: values?.kurv_pricing_amex_rate,
    kurv_pricing_amex_txn_fee: values?.kurv_pricing_amex_txn_fee
  });

  return (
    <>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Swiped rates</h6>
            <div className={styles.accepts}>
              <img src={visa} />
              <img src={mastercard} />
              <img src={discover} />
            </div>
          </div>

          <div className={styles.body}>
            <TextInput
              label={"Swiped rate"}
              placeholder={"0.00"}
              suffix={"%"}
              type="text"
              id={"kurv_pricing_swiped_rate"}
              name={"kurv_pricing_swiped_rate"}
              value={values.kurv_pricing_swiped_rate}
              onBlur={handleBlur}
              touched={touched?.kurv_pricing_swiped_rate}
              errored={errors?.kurv_pricing_swiped_rate}
              error={errors?.kurv_pricing_swiped_rate}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.kurv_pricing?.kurv_pricing_swiped_rate?.soft_limit,
                values.kurv_pricing_swiped_rate,
                errors.kurv_pricing_swiped_rate,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "kurv_pricing_swiped_rate",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
            <TextInput
              label={"Swiped Txn Fee"}
              placeholder={"0.00"}
              prefix={"$"}
              type="text"
              id={"kurv_pricing_swiped_txn_fee"}
              name={"kurv_pricing_swiped_txn_fee"}
              value={values.kurv_pricing_swiped_txn_fee}
              onBlur={handleBlur}
              touched={touched?.kurv_pricing_swiped_txn_fee}
              errored={errors?.kurv_pricing_swiped_txn_fee}
              error={errors?.kurv_pricing_swiped_txn_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.kurv_pricing?.kurv_pricing_swiped_txn_fee?.soft_limit,
                values.kurv_pricing_swiped_txn_fee,
                errors.kurv_pricing_swiped_txn_fee,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "kurv_pricing_swiped_txn_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
          </div>
        </div>

        <div className={styles.card}>
          <div className={styles.header}>
            <h6>Keyed rates</h6>
            <div className={styles.accepts}>
              <img src={visa} />
              <img src={mastercard} />
              <img src={discover} />
            </div>
          </div>

          <div className={styles.body}>
            <TextInput
              label={"Keyed rate"}
              placeholder={"0.00"}
              suffix={"%"}
              type="text"
              id={"kurv_pricing_keyed_rate"}
              name={"kurv_pricing_keyed_rate"}
              value={values.kurv_pricing_keyed_rate}
              onBlur={handleBlur}
              touched={touched?.kurv_pricing_keyed_rate}
              errored={errors?.kurv_pricing_keyed_rate}
              error={errors?.kurv_pricing_keyed_rate}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.kurv_pricing?.kurv_pricing_keyed_rate?.soft_limit,
                values.kurv_pricing_keyed_rate,
                errors.kurv_pricing_keyed_rate,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "kurv_pricing_keyed_rate",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
            <TextInput
              label={"Keyed Txn Fee"}
              placeholder={"0.00"}
              prefix={"$"}
              type="text"
              id={"kurv_pricing_keyed_txn_fee"}
              name={"kurv_pricing_keyed_txn_fee"}
              value={values.kurv_pricing_keyed_txn_fee}
              onBlur={handleBlur}
              touched={touched?.kurv_pricing_keyed_txn_fee}
              errored={errors?.kurv_pricing_keyed_txn_fee}
              error={errors?.kurv_pricing_keyed_txn_fee}
              hasWarning={getSoftLimitWarning(
                pricingDefaults?.kurv_pricing?.kurv_pricing_keyed_txn_fee
                  ?.soft_limit,
                values.kurv_pricing_keyed_txn_fee,
                errors.kurv_pricing_keyed_txn_fee,
              )}
              cleaveOptions={{
                numeral: true,
                numeralDecimalScale: 2,
                numeralIntegerScale: 4,
                numeralPositiveOnly: true,
                onValueChanged: (e) => {
                  handleChange({
                    target: {
                      name: "kurv_pricing_keyed_txn_fee",
                      value: e.target.rawValue,
                    },
                  });
                },
              }}
              disabled={nonEditableTemplateOrPricingRestricted}
            />
          </div>
        </div>

        <div className={`${styles.card} ${styles.card3}`}>
          <div className={styles.header}>
            <h6>Amex rates</h6>
            <div className={styles.accepts}>
              <img src={amex} />
            </div>
          </div>

          <Switch
            id={'kurv_pricing_amex_toggle'}
            name={'kurv_pricing_amex_toggle'}
            label="Enable Amex pricing"
            checked={values?.kurv_pricing_amex_toggle === "yes"}
            onChange={(e) => {
              handleChange(e);
              setFieldValue('kurv_pricing_amex_toggle', e.target.checked ? "yes" : "no");
              if (!e.target.checked) {
                setFieldValue("kurv_pricing_amex_rate", 0);
                setFieldValue("kurv_pricing_amex_txn_fee", 0);
              }else {
                setFieldValue("kurv_pricing_amex_rate", backup.kurv_pricing_amex_rate);
                setFieldValue("kurv_pricing_amex_txn_fee", backup.kurv_pricing_amex_txn_fee);
              }
            }}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue('kurv_pricing_amex_toggle', e.target.checked ? "yes" : "no");
              if (!e.target.checked) {
                setFieldValue("kurv_pricing_amex_rate", 0);
                setFieldValue("kurv_pricing_amex_txn_fee", 0);
              }else {
                setFieldValue("kurv_pricing_amex_rate", backup.kurv_pricing_amex_rate);
                setFieldValue("kurv_pricing_amex_txn_fee", backup.kurv_pricing_amex_txn_fee);
              }
            }}
            disabled={nonEditableTemplateOrPricingRestricted}
          />

          {values?.kurv_pricing_amex_toggle === 'yes' && (
            <>
              <div className={styles.body}>
                <TextInput
                  label={"Amex rate"}
                  placeholder={"0.00"}
                  suffix={"%"}
                  type="text"
                  id={"kurv_pricing_amex_rate"}
                  name={"kurv_pricing_amex_rate"}
                  value={values.kurv_pricing_amex_rate}
                  onBlur={handleBlur}
                  touched={touched?.kurv_pricing_amex_rate}
                  errored={errors?.kurv_pricing_amex_rate}
                  error={errors?.kurv_pricing_amex_rate}
                  hasWarning={getSoftLimitWarning(
                    pricingDefaults?.kurv_pricing?.kurv_pricing_amex_rate?.soft_limit,
                    values.kurv_pricing_amex_rate,
                    errors.kurv_pricing_amex_rate,
                  )}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "kurv_pricing_amex_rate",
                          value: e.target.rawValue,
                        },
                      });
                      setBackup(prev => ({
                        ...prev,
                        kurv_pricing_amex_rate: e.target.rawValue,
                      }));
                    },
                  }}
                  disabled={nonEditableTemplateOrPricingRestricted}
                />
                <TextInput
                  label={"Amex Txn Fee"}
                  placeholder={"0.00"}
                  prefix={"$"}
                  type="text"
                  id={"kurv_pricing_amex_txn_fee"}
                  name={"kurv_pricing_amex_txn_fee"}
                  value={values.kurv_pricing_amex_txn_fee}
                  onBlur={handleBlur}
                  touched={touched?.kurv_pricing_amex_txn_fee}
                  errored={errors?.kurv_pricing_amex_txn_fee}
                  error={errors?.kurv_pricing_amex_txn_fee}
                  hasWarning={getSoftLimitWarning(
                    pricingDefaults?.kurv_pricing?.kurv_pricing_amex_txn_fee
                      ?.soft_limit,
                    values.kurv_pricing_amex_txn_fee,
                    errors.kurv_pricing_amex_txn_fee,
                  )}
                  cleaveOptions={{
                    numeral: true,
                    numeralDecimalScale: 2,
                    numeralIntegerScale: 4,
                    numeralPositiveOnly: true,
                    onValueChanged: (e) => {
                      handleChange({
                        target: {
                          name: "kurv_pricing_amex_txn_fee",
                          value: e.target.rawValue,
                        },
                      });
                      setBackup(prev => ({
                        ...prev,
                        kurv_pricing_amex_txn_fee: e.target.rawValue,
                      }));
                    },
                  }}
                  disabled={nonEditableTemplateOrPricingRestricted}
                />
              </div>
            </>
          )}
        </div>
      </div>

      <PinBasedDebit pricingModel="kurv_pricing" />
    </>
  );
};

export default KurvPricing;
